import {useCallback} from 'react';
import {useMutation} from '@apollo/client';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';
import {RegionalCostsDriverCost} from '../store/types';
import {receivedCountryDriverCost} from '../store/slice';
import updateCountryDriverCostEntryMutation from '../graphql/updateCountryDriverCostEntryMutation';

interface UseUpdateCountryDriverCostsMutationResult {
  updateCountryDriverCosts: (
    cost: RegionalCostsDriverCost,
    countryId: string,
    year: number,
    onSuccess?: (cost?: RegionalCostsDriverCost) => void
  ) => Promise<void>;
}

export const useUpdateCountryDriverCostsMutation =
  (): UseUpdateCountryDriverCostsMutationResult => {
    const dispatch = useAppDispatch();
    const [updateCountryDriverCostEntry] = useMutation(
      updateCountryDriverCostEntryMutation,
      {
        errorPolicy: 'all'
      }
    );

    const updateCountryDriverCosts = useCallback(
      async (
        cost: RegionalCostsDriverCost,
        countryId: string,
        year: number,
        onSuccess?: (cost?: RegionalCostsDriverCost) => void
      ) => {
        try {
          const variables = {
            ...cost,
            countryId,
            year
          };
          const result = await updateCountryDriverCostEntry({variables});

          if (result.errors && result.errors.length > 0) {
            const errorMessage = result.errors[0].message;
            console.error(errorMessage);
            return;
          }

          dispatch(
            receivedCountryDriverCost(result.data.updateCountryDriverCostEntry)
          );
          onSuccess?.(result.data.updateCountryDriverCostEntry);
        } catch (err: any) {
          console.error(
            `Unexpected error while updating country driver cost entry: ${err}`
          );
        }
      },
      [dispatch, updateCountryDriverCostEntry]
    );

    return {updateCountryDriverCosts};
  };
